module.exports = __webpack_public_path__ + "static/media/interface_usability.22e50b88.png";